// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const uploadImageUrl = "api/xngage/hawksearch/v1/imageSearch/upload";

export interface ImageSearchApiParameter extends ApiParameter {
    imageData: string;
}

export interface ImageSearchApiResult {
    key: string;
}

export async function ImageSearchService(
    parameter: ImageSearchApiParameter,
): Promise<ServiceResult<ImageSearchApiResult>> {
    try {
        const imageUploadModal = await post<ImageSearchApiParameter>(`${uploadImageUrl}`, parameter);
        return {
            result: imageUploadModal as unknown as ImageSearchApiResult,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
